<template>
	<div :class="['box', { 'faulty': this.faulty }]">
		<div :class="titleClasses">
			<div>
				<a v-if="toggleable" href="#" @click.prevent="showContent = !showContent" class="d-inline-block">
					<Icon icon="triangle-right" :rotate="showContent ? 90 : 0" color="red" />
				</a>
				{{ title }}
				<span v-if="tooltip" class="ml-2" v-b-tooltip.html :title="tooltip">
					<Icon icon="info" />
				</span>
			</div>
			<div v-if="editable" class="actions">
				<a href="#" @click.prevent="$emit('edit')">
					<Icon icon="edit" color="red"/>
				</a>
			</div>
		</div>
		<div :class="['content', { 'd-none': !showContent }]">
			<div v-if="hasInfoTopSlot" class="info-top">
				<slot name="info-top"/>
			</div>
			<slot/>
			<div v-if="hasInfoSlot" class="info">
				<slot name="info"/>
			</div>
		</div>
	</div>
</template>

<script>
import Icon from "@/vue/icon/Icon"
import {isDefined} from "@/helper/Value";

export default {

	components: {
		Icon
	},

	props: {
		title: {
			type: String,
			required: true,
		},
		titleColor: {
			type: String,
			required: false,
		},
		editable: {
			type: Boolean,
			required: false,
			default: false,
		},
		faulty: {
			type: Boolean,
			required: false,
			default: false,
		},
		tooltip: {
			type: String,
			required: false,
		},
		toggleable: {
			type: Boolean,
			required: false,
			default: false,
		},
	},

	data ()
	{
		return {
			showContent: isDefined(this.forceShowContent) ? this.forceShowContent : true,
		};
	},

	computed: {
		titleClasses ()
		{
			let classes = [ 'title' ];

			if (this.titleColor)
			{
				classes.push('color-' + this.titleColor);
			}

			return classes;
		},
		hasInfoSlot ()
		{
			return !!this.$slots.info;
		},
		hasInfoTopSlot ()
		{
			return !!this.$slots['info-top'];
		},
	},
}
</script>